import { TMouseOrTouchEvent } from '../types';
import { getUniversalPosition } from './getUniversalPosition';

/** @description Возвращает универсальные координаты для тач нажатия и клика
 * @param e {TMouseOrTouchEvent} объект события мыши
 * @param lastCursorPosition {{ x: number, y: number }} прошлые координаты мыши
 * @return {{ x: number, y: number }}
 */
export const getCoordinates = (e: TMouseOrTouchEvent, lastCursorPosition: { x: number; y: number }) => {
  const { x: lastX, y: lastY } = lastCursorPosition;
  const { x, y } = getUniversalPosition(e);

  return {
    x,
    y,
    lastY,
    lastX,
    deltaX: lastX - x,
    deltaY: lastY - y,
  };
};
